import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateIapPollRequestBody,
  IApiCreateIapPollResponseBody,
} from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { iapPollQueryKeyFactory } from './useIapPollQuery';
import { iapPollsQueryKeyFactory } from './useIapPollsQuery';

export type IUseCreateIapPollMutationValues = {
  appId: string;
  body: IApiCreateIapPollRequestBody;
};

export const useCreateIapPollMutation = (): UseMutationResult<
  IApiCreateIapPollResponseBody,
  unknown,
  IUseCreateIapPollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateIapPollMutationValues) =>
      api.iapPolls.create(values.appId, values.body),
    onSuccess: async (createdIapPoll, values) => {
      queryClient.setQueryData(
        iapPollQueryKeyFactory({
          ...values,
          iapPollId: createdIapPoll._id,
        })!,
        createdIapPoll,
      );
      await queryClient.invalidateQueries({
        queryKey: iapPollsQueryKeyFactory(),
      });
    },
  });
};
